/* Isa Bayong theme — original JS: announcement, hero slideshow, header scroll, ticker, footer reveal. */
(function () {
  'use strict';
  var body = document.body;
  var isHome = body.classList.contains('bt-home');

  /* ---------- deferred decorative images ----------
     Background images do not support native loading="lazy". Observe the image
     layers instead so off-screen sections and hidden product tabs do not compete
     with the first hero for bandwidth. */
  (function () {
    var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        loadBackground(entry.target, 'lazyBg');
        loadPalmWash(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px' }) : null;

    function cssUrl(url) {
      return 'url("' + String(url).replace(/"/g, '%22') + '")';
    }

    function loadBackground(el, key) {
      var url = el.dataset[key];
      if (key === 'lazyBg' && el.dataset.lazyMobileBg && window.matchMedia('(max-width: 749px)').matches) {
        url = el.dataset.lazyMobileBg;
      }
      if (!url) return;
      el.style.backgroundImage = cssUrl(url);
      delete el.dataset[key];
      if (key === 'lazyBg') delete el.dataset.lazyMobileBg;
    }

    function loadPalmWash(el) {
      if (!el.dataset.lazyPalm) return;
      el.style.setProperty('--bt-palm-wash-image', cssUrl(el.dataset.lazyPalm));
      delete el.dataset.lazyPalm;
    }

    function watch(root) {
      [].forEach.call((root || document).querySelectorAll('[data-lazy-bg]'), function (el) {
        if (observer) observer.observe(el);
        else loadBackground(el, 'lazyBg');
      });
      [].forEach.call((root || document).querySelectorAll('[data-lazy-palm]'), function (el) {
        if (observer) observer.observe(el);
        else loadPalmWash(el);
      });
    }

    function loadHoverImage(event) {
      var card = event.target.closest && event.target.closest('.bt-card');
      if (!card) return;
      var alt = card.querySelector('[data-lazy-hover-bg]');
      if (alt) loadBackground(alt, 'lazyHoverBg');
    }

    var footerLoaded = false;
    function maybeLoadFooter() {
      if (footerLoaded) return;
      var footer = document.querySelector('[data-lazy-footer-bg]');
      if (!footer) return;
      var remaining = document.documentElement.scrollHeight - ((window.scrollY || 0) + window.innerHeight);
      if (remaining > window.innerHeight * 1.5) return;
      footer.style.setProperty('--ibf-bg-image', cssUrl(footer.dataset.lazyFooterBg));
      delete footer.dataset.lazyFooterBg;
      footerLoaded = true;
    }

    watch(document);
    document.addEventListener('pointerover', loadHoverImage, { passive: true });
    document.addEventListener('focusin', loadHoverImage);
    window.addEventListener('scroll', maybeLoadFooter, { passive: true });
    window.addEventListener('resize', maybeLoadFooter);
    window.addEventListener('load', function () {
      maybeLoadFooter();
    }, { once: true });
    document.addEventListener('shopify:section:load', function (event) {
      watch(event.target);
      maybeLoadFooter();
    });
  })();

  /* ---------- announcement carousel ---------- */
  (function () {
    var ann = document.getElementById('btAnnounce');
    var msg = document.getElementById('btAnnMsg');
    var pause = document.getElementById('btAnnPause');
    var close = document.getElementById('btAnnClose');
    if (!ann || !msg || !pause) return;
    var MESSAGES = [
      'New In: Women’s Pre-Fall 2026. <a href="#">Shop Now</a>.',
      'Free standard U.S. shipping on orders of $100 or more. <a href="#">Learn More</a>.',
      'Discover our Hand Woven Collection. <a href="#">Explore</a>.',
      'Each Isa Bayong bag is woven by hand. <a href="#">Our Craft</a>.'
    ];
    var annData = document.getElementById('btAnnData');
    if (annData) { try { var parsed = JSON.parse(annData.textContent); if (parsed && parsed.length) MESSAGES = parsed; } catch (e) {} }
    var ICON_PAUSE = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><rect x="4.2" y="3" width="2.2" height="10" rx="1" fill="currentColor"/><rect x="9.6" y="3" width="2.2" height="10" rx="1" fill="currentColor"/></svg>';
    var ICON_PLAY = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M5 3.2 L12.5 8 L5 12.8 Z" fill="currentColor"/></svg>';
    var idx = 0, paused = false, timer = null, startTimer = null;
    msg.innerHTML = MESSAGES[0]; pause.innerHTML = ICON_PAUSE;
    function advance() { ann.classList.add('is-fading'); setTimeout(function () { idx = (idx + 1) % MESSAGES.length; msg.innerHTML = MESSAGES[idx]; ann.classList.remove('is-fading'); }, 300); }
    function play() { if (timer) clearInterval(timer); timer = setInterval(advance, 4500); }
    function stop() {
      if (startTimer) { clearTimeout(startTimer); startTimer = null; }
      if (timer) { clearInterval(timer); timer = null; }
    }
    pause.addEventListener('click', function () { paused = !paused; if (paused) { stop(); pause.innerHTML = ICON_PLAY; pause.setAttribute('aria-pressed', 'true'); } else { play(); pause.innerHTML = ICON_PAUSE; pause.setAttribute('aria-pressed', 'false'); } });
    if (close) close.addEventListener('click', function () { stop(); ann.style.maxHeight = ann.offsetHeight + 'px'; ann.offsetHeight; requestAnimationFrame(function () { ann.style.maxHeight = '0px'; ann.style.opacity = '0'; }); });
    startTimer = setTimeout(function () {
      startTimer = null;
      if (!paused) play();
    }, 8000);
  })();

  /* ---------- hero slideshow (fade, 10s) + header theme adaptation ---------- */
  (function () {
    var hero = document.getElementById('btHero'); if (!hero) return;
    var slides = hero.querySelectorAll('.bt-hero__slide');
    var dots = hero.querySelectorAll('.bt-hero__dot');
    var cur = 0, N = slides.length, timer = null;
    function applyTheme(i) {
      var dark = slides[i].classList.contains('bt-hero__slide--dark');
      body.classList.toggle('bt-hero-dark', dark);
      body.classList.toggle('bt-hero-light', !dark);
    }
    function loadSlideImage(slide) {
      if (!slide || !slide.dataset.lazyHeroBg) return;
      function cssUrl(url) { return 'url("' + String(url).replace(/"/g, '%22') + '")'; }
      slide.style.setProperty('--bt-hero-image', cssUrl(slide.dataset.lazyHeroBg));
      slide.style.setProperty('--bt-hero-mobile-image', cssUrl(slide.dataset.lazyHeroMobileBg || slide.dataset.lazyHeroBg));
      delete slide.dataset.lazyHeroBg;
      delete slide.dataset.lazyHeroMobileBg;
    }
    function go(n) {
      n = (n + N) % N;
      var restartingCurrent = n === cur;
      loadSlideImage(slides[n]);
      slides[cur].classList.remove('is-active');
      if (dots[cur]) { dots[cur].classList.remove('is-active'); dots[cur].setAttribute('aria-current', 'false'); }
      slides[n].classList.add('is-active');
      if (dots[n]) {
        // A forced layout is only needed when the current indicator is selected again.
        // Normal automatic changes stay entirely on the compositor path.
        if (restartingCurrent) void dots[n].offsetWidth;
        dots[n].classList.add('is-active');
        dots[n].setAttribute('aria-current', 'true');
      }
      cur = n; applyTheme(cur);
    }
    function play() { stop(); timer = setInterval(function () { go(cur + 1); }, 10000); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    [].forEach.call(dots, function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-i'), 10)); play(); }); });

    /* Mobile swipe: horizontal intent changes slides while vertical movement remains
       native page scrolling. A short threshold prevents accidental slide changes. */
    var touchX = 0, touchY = 0, touchTime = 0;
    hero.addEventListener('touchstart', function (event) {
      if (!event.touches || event.touches.length !== 1) return;
      touchX = event.touches[0].clientX;
      touchY = event.touches[0].clientY;
      touchTime = Date.now();
    }, { passive: true });
    hero.addEventListener('touchend', function (event) {
      if (!touchTime || !event.changedTouches || event.changedTouches.length !== 1 || N < 2) return;
      var dx = event.changedTouches[0].clientX - touchX;
      var dy = event.changedTouches[0].clientY - touchY;
      var elapsed = Date.now() - touchTime;
      touchTime = 0;
      if (elapsed > 900 || Math.abs(dx) < 48 || Math.abs(dx) <= Math.abs(dy) * 1.2) return;
      go(cur + (dx < 0 ? 1 : -1));
      play();
    }, { passive: true });
    hero.addEventListener('touchcancel', function () { touchTime = 0; }, { passive: true });

    // no pause-on-hover: the hero is full-viewport, so the cursor sits on it almost
    // permanently and the slideshow progress would just freeze there.
    // pause only when the tab is hidden, so the timer can't drift out of sync.
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : play(); });
    applyTheme(0); play();
  })();

  /* ---------- header: transparent over hero at top, solid on scroll, premium slide ---------- */
  (function () {
    var root = document.getElementById('btHeadroot'); if (!root) return;
    var lastY = window.scrollY || 0;
    // product pages keep the nav pinned: the info column is sticky there, so a header
    // that slides away leaves the pinned panel floating under nothing.
    var pinned = body.classList.contains('bt-pinned');
    function onScroll() {
      var y = window.scrollY || 0;
      var atTop = y < 60;
      if (isHome) body.classList.toggle('bt-attop', atTop);
      // Keep an open navigation surface anchored while the document moves.
      // Otherwise the direction-based header reveal can translate the header
      // (and its menu) out of view during wheel or touch scrolling.
      if (body.classList.contains('bt-mobile-menu-open') || body.classList.contains('bt-mega-open')) {
        root.style.transform = 'translateY(0)';
        root.style.opacity = '1';
        lastY = y;
        return;
      }
      if (pinned) { root.style.transform = 'translateY(0)'; root.style.opacity = '1'; lastY = y; return; }
      if (atTop || y <= 2) { root.style.transform = 'translateY(0)'; root.style.opacity = '1'; }
      else if (y > lastY + 4) { root.style.transform = 'translateY(-100%)'; root.style.opacity = '0'; }
      else if (y < lastY - 4) { root.style.transform = 'translateY(0)'; root.style.opacity = '1'; }
      lastY = y;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  /* ---------- mobile navigation drawer ---------- */
  (function () {
    var toggle = document.getElementById('btMobileMenuToggle');
    var drawer = document.getElementById('btMobileMenu');
    var backdrop = document.getElementById('btMobileMenuBackdrop');
    if (!toggle || !drawer) return;
    var mobile = window.matchMedia('(max-width: 999px)');
    var lastFocused = null;

    function setOpen(open, returnFocus) {
      if (!mobile.matches) open = false;
      body.classList.toggle('bt-mobile-menu-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) {
        lastFocused = document.activeElement;
      } else {
        [].forEach.call(drawer.querySelectorAll('details[open]'), function (details) { details.removeAttribute('open'); });
        if (returnFocus && lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      }
    }

    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true', false);
    });
    if (backdrop) backdrop.addEventListener('click', function () { setOpen(false, true); });
    drawer.addEventListener('click', function (event) {
      if (event.target.closest('a')) setOpen(false, false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && body.classList.contains('bt-mobile-menu-open')) setOpen(false, true);
    });
    function closeResponsiveOverlays() {
      setOpen(false, false);
      if (mobile.matches) return;

      // Shopify's theme editor can change preview widths without navigating.
      // Never carry a mobile drawer or a half-open cart backdrop into desktop.
      body.classList.remove('bt-mobile-menu-open', 'overflow-hidden-mobile');
      var cartDrawer = document.querySelector('cart-drawer.active');
      if (cartDrawer) {
        if (typeof cartDrawer.close === 'function') cartDrawer.close();
        else {
          cartDrawer.classList.remove('active', 'animate');
          body.classList.remove('overflow-hidden');
        }
      }
    }
    var closeAtDesktop = function () { closeResponsiveOverlays(); };
    if (mobile.addEventListener) mobile.addEventListener('change', closeAtDesktop);
    else mobile.addListener(closeAtDesktop);
    window.addEventListener('pageshow', closeResponsiveOverlays);
  })();

  /* ---------- provenance ticker (seamless marquee) ---------- */
  (function () {
    var BAG = '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5.5 8h13l-1 11.5a1 1 0 0 1-1 .9H7.5a1 1 0 0 1-1-.9L5.5 8z" stroke="currentColor" stroke-width="1.1" stroke-linejoin="round"/><path d="M8.7 9.4V7a3.3 3.3 0 0 1 6.6 0v2.4" stroke="currentColor" stroke-width="1.1" stroke-linecap="round"/></svg>';
    [].forEach.call(document.querySelectorAll('.bt-ticker__track'), function (track) {
      var phrase = track.getAttribute('data-text') || 'Each bag made by a named weaver';
      var one = '<span class="bt-ticker__item"><span>' + phrase + '</span>' + BAG + '</span>';
      var half = ''; for (var i = 0; i < 6; i++) half += one;
      track.innerHTML = half + half;   // two identical halves -> translateX(-50%) loops seamlessly
    });
  })();

  /* ---------- image-text overlay slideshow (fade, 10s) ---------- */
  /* class-driven, not by id: the page can carry more than one of these */
  [].forEach.call(document.querySelectorAll('.bt-overlay'), function (box) {
    var slides = box.querySelectorAll('.bt-overlay__slide');
    var dots = box.querySelectorAll('.bt-overlay__dot');
    var cur = 0, N = slides.length, timer = null;
    function go(n) {
      n = (n + N) % N;
      var restartingCurrent = n === cur;
      slides[cur].classList.remove('is-active');
      if (dots[cur]) { dots[cur].classList.remove('is-active'); dots[cur].setAttribute('aria-current', 'false'); }
      slides[n].classList.add('is-active');
      if (dots[n]) {
        if (restartingCurrent) void dots[n].offsetWidth;
        dots[n].classList.add('is-active');
        dots[n].setAttribute('aria-current', 'true');
      }
      cur = n;
      // dots flip dark over a light slide, the way the hero drives its theme
      box.classList.toggle('bt-overlay--light', slides[n].classList.contains('bt-overlay__slide--light'));
    }
    // The progress animation resumes where it paused, but play() restarts the 10s
    // interval from zero — replay the active segment so the two stay in step.
    function restartProgress() {
      var d = box.querySelector('.bt-overlay__dot.is-active');
      if (d) { d.classList.remove('is-active'); void d.offsetWidth; d.classList.add('is-active'); }
    }
    function play() { stop(); timer = setInterval(function () { go(cur + 1); }, 10000); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    [].forEach.call(dots, function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-i'), 10)); play(); }); });

    /* Swipe on touch, click-drag with a mouse, and two-finger horizontal
       trackpad gestures. Vertical movement remains native page scrolling. */
    var pointerId = null, startX = 0, startY = 0, startTime = 0, suppressClick = false;
    box.addEventListener('pointerdown', function (event) {
      if (N < 2 || !event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
      if (event.target.closest('a,button')) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      startTime = Date.now();
      box.classList.add('is-dragging');
      if (box.setPointerCapture) {
        try { box.setPointerCapture(pointerId); } catch (error) {}
      }
    });
    box.addEventListener('pointerup', function (event) {
      if (event.pointerId !== pointerId) return;
      var dx = event.clientX - startX;
      var dy = event.clientY - startY;
      var elapsed = Date.now() - startTime;
      pointerId = null;
      box.classList.remove('is-dragging');
      if (elapsed > 1000 || Math.abs(dx) < 48 || Math.abs(dx) <= Math.abs(dy) * 1.2) return;
      suppressClick = true;
      setTimeout(function () { suppressClick = false; }, 400);
      go(cur + (dx < 0 ? 1 : -1));
      play();
    });
    box.addEventListener('pointercancel', function () {
      pointerId = null;
      box.classList.remove('is-dragging');
    });
    box.addEventListener('click', function (event) {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);

    var wheelTotal = 0, wheelReset = null, wheelLocked = false;
    box.addEventListener('wheel', function (event) {
      if (N < 2 || Math.abs(event.deltaX) <= Math.abs(event.deltaY) * 1.2) return;
      event.preventDefault();
      if (wheelLocked) return;
      wheelTotal += event.deltaX;
      clearTimeout(wheelReset);
      wheelReset = setTimeout(function () { wheelTotal = 0; }, 140);
      if (Math.abs(wheelTotal) < 45) return;
      go(cur + (wheelTotal > 0 ? 1 : -1));
      play();
      wheelTotal = 0;
      wheelLocked = true;
      setTimeout(function () { wheelLocked = false; }, 550);
    }, { passive: false });

    // Keep autoplay independent from pointer position. A wheel/trackpad scroll
    // often leaves the pointer over the slideshow, which previously froze both
    // the timer and its progress indicator until the pointer moved away.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); box.classList.add('is-paused'); return; }
      box.classList.remove('is-paused'); restartProgress(); play();
    });
    go(0);
    if (N > 1) play();   // a one-slide instance has nothing to advance to
  });

  /* ---------- image parallax: media moves, clipped frames stay fixed ---------- */
  (function () {
    var frames = document.querySelectorAll('.bt-hero[data-parallax], .bt-story[data-parallax], .bt-overlay[data-parallax]');
    if (!frames.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var ticking = false;

    function reset() {
      [].forEach.call(frames, function (frame) {
        if (frame.classList.contains('bt-hero')) {
          frame.style.removeProperty('--bt-hero-scroll-y');
          frame.style.removeProperty('--bt-hero-foreground-scroll-y');
          return;
        }
        [].forEach.call(frame.querySelectorAll('.bt-hero__media, .bt-story__media, .bt-overlay__media'), function (media) {
          media.style.transform = '';
        });
      });
    }

    function update() {
      ticking = false;
      if (reduce.matches) { reset(); return; }
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var travel = window.innerWidth < 750 ? 34 : 52;

      [].forEach.call(frames, function (frame) {
        var rect = frame.getBoundingClientRect();
        if (rect.bottom < -80 || rect.top > vh + 80) return;
        var progress = ((rect.top + rect.height / 2) - vh / 2) / ((vh + rect.height) / 2);
        if (progress < -1) progress = -1;
        else if (progress > 1) progress = 1;
        var y = (progress * -travel).toFixed(2);
        if (frame.classList.contains('bt-hero')) {
          frame.style.setProperty('--bt-hero-scroll-y', y + 'px');
          frame.style.setProperty('--bt-hero-foreground-scroll-y', (parseFloat(y) * 1.28).toFixed(2) + 'px');
          return;
        }
        [].forEach.call(frame.querySelectorAll('.bt-story__media, .bt-overlay__media'), function (media) {
          media.style.transform = 'translate3d(0,' + y + 'px,0)';
        });
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    if (reduce.addEventListener) reduce.addEventListener('change', update);
    update();
  })();

  /* ---------- hero cursor depth: foliage travels farther than the photograph ---------- */
  (function () {
    var hero = document.querySelector('.bt-hero[data-parallax]');
    if (!hero || !hero.querySelector('.bt-hero__foreground')) return;
    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var x = 0, y = 0, targetX = 0, targetY = 0, raf = 0;

    function apply() {
      raf = 0;
      x += (targetX - x) * .13;
      y += (targetY - y) * .13;
      hero.style.setProperty('--bt-hero-bg-x', (x * 8).toFixed(2) + 'px');
      hero.style.setProperty('--bt-hero-bg-y', (y * 5).toFixed(2) + 'px');
      hero.style.setProperty('--bt-hero-foreground-x', (x * 36).toFixed(2) + 'px');
      hero.style.setProperty('--bt-hero-foreground-y', (y * 24).toFixed(2) + 'px');
      if (Math.abs(targetX - x) > .002 || Math.abs(targetY - y) > .002) raf = requestAnimationFrame(apply);
    }

    function schedule() { if (!raf) raf = requestAnimationFrame(apply); }
    function reset() { targetX = 0; targetY = 0; schedule(); }
    function onPointerMove(event) {
      if (!finePointer.matches || reduce.matches) { reset(); return; }
      var rect = hero.getBoundingClientRect();
      targetX = Math.max(-1, Math.min(1, ((event.clientX - rect.left) / rect.width - .5) * 2));
      targetY = Math.max(-1, Math.min(1, ((event.clientY - rect.top) / rect.height - .5) * 2));
      schedule();
    }

    hero.addEventListener('pointermove', onPointerMove, { passive: true });
    hero.addEventListener('pointerleave', reset, { passive: true });
    if (reduce.addEventListener) reduce.addEventListener('change', reset);
    if (finePointer.addEventListener) finePointer.addEventListener('change', reset);
  })();

  /* ---------- product carousels (featured rows) ---------- */
  [].forEach.call(document.querySelectorAll('.bt-featured .bt-cards'), function (track) {
    if (track.closest('.bt-carousel')) return;
    var wrap = document.createElement('div'); wrap.className = 'bt-carousel';
    track.parentNode.insertBefore(wrap, track); wrap.appendChild(track);
    if (track.style.display === 'none') { track.style.display = ''; wrap.style.display = 'none'; }
    function mkArrow(dir) {
      var b = document.createElement('button');
      b.className = 'bt-carousel__arrow bt-carousel__arrow--' + dir;
      b.type = 'button'; b.setAttribute('aria-label', dir === 'prev' ? 'Previous' : 'Next');
      b.innerHTML = dir === 'prev'
        ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        : '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      return b;
    }
    var prev = mkArrow('prev'), next = mkArrow('next');
    wrap.appendChild(prev); wrap.appendChild(next);
    function step() { var c = track.querySelector('.bt-card'); return c ? (c.offsetWidth + 22) * 2 : track.clientWidth * 0.8; }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    function update() {
      var media = track.querySelector('.bt-card__media');
      if (media) {
        var mr = media.getBoundingClientRect(), wr = wrap.getBoundingClientRect();
        if (mr.height) { var top = (mr.top - wr.top) + mr.height / 2; prev.style.top = top + 'px'; next.style.top = top + 'px'; }
      }
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    setTimeout(update, 60); update();
  });

  /* ---------- featured collection tabs (switch product groups) ---------- */
  [].forEach.call(document.querySelectorAll('.bt-tabs'), function (bar) {
    var tabs = bar.querySelectorAll('.bt-tab');
    var section = bar.closest('.bt-featured');
    var ink = bar.querySelector('.bt-tabs__ink');
    function moveInk(t) {
      if (!ink || !t) return;
      ink.style.width = t.offsetWidth + 'px';
      ink.style.transform = 'translateX(' + t.offsetLeft + 'px)';
    }
    function activeTab() { return bar.querySelector('.bt-tab.is-active') || tabs[0]; }
    function show(i) {
      if (!section) return;
      [].forEach.call(section.querySelectorAll('.bt-cards[data-tab]'), function (g) {
        var target = g.closest('.bt-carousel') || g;
        target.style.display = (g.getAttribute('data-tab') === String(i)) ? '' : 'none';
      });
      [].forEach.call(section.querySelectorAll('.bt-featured__collection-foot[data-tab]'), function (foot) {
        foot.style.display = (foot.getAttribute('data-tab') === String(i)) ? '' : 'none';
      });
      window.dispatchEvent(new Event('resize'));   // refresh carousel arrow states for the shown group
    }
    [].forEach.call(tabs, function (t, i) {
      t.addEventListener('click', function () {
        [].forEach.call(tabs, function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        moveInk(t);
        show(t.getAttribute('data-tab') || i);
      });
    });
    // init: if this section uses tab groups, show only the first
    if (section && section.querySelector('.bt-cards[data-tab]')) show(0);
    if (ink) {
      bar.classList.add('bt-tabs--ink');           // hand the indicator over from the per-tab border
      moveInk(activeTab());                        // place it before enabling the transition, so it does not fly in
      // setTimeout, not rAF: rAF never fires while the tab is hidden, which would
      // leave the ink stuck without its transition until the page is looked at
      setTimeout(function () { bar.classList.add('bt-tabs--anim'); }, 0);
      // tab widths shift once the webfont swaps in, and again on resize
      window.addEventListener('resize', function () { moveInk(activeTab()); });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { moveInk(activeTab()); });
      }
    }
  });

  /* ---------- product: size chips + gallery thumbnails ---------- */
  (function () {
    var sizes = document.querySelectorAll('.bt-product__sizes .bt-size');
    [].forEach.call(sizes, function (b) {
      b.addEventListener('click', function () {
        [].forEach.call(sizes, function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
      });
    });
    var main = document.querySelector('.bt-product__main');
    var thumbs = document.querySelectorAll('.bt-thumb');
    [].forEach.call(thumbs, function (t) {
      t.addEventListener('click', function () {
        if (main) main.style.backgroundImage = t.style.backgroundImage;
        [].forEach.call(thumbs, function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  })();

  /* ---------- mega menu (hover + click, Esc to close) ---------- */
  (function () {
    var triggers = document.querySelectorAll('.bt-mainnav__item[data-mega]');
    var panels = document.querySelectorAll('.bt-mega');
    var group = document.querySelector('.bt-headergroup');
    var desktop = window.matchMedia('(min-width: 1000px)');
    if (!triggers.length || !panels.length) return;
    var timer = null;
    function closeAll() {
      clearTimeout(timer);
      body.classList.remove('bt-mega-open');
      [].forEach.call(panels, function (p) {
        p.classList.remove('is-open');
        p.setAttribute('aria-hidden', 'true');
      });
      [].forEach.call(triggers, function (t) { t.setAttribute('aria-expanded', 'false'); });
    }
    function open(i, trigger) {
      // The full-width collection panel is a desktop interaction. Mobile uses
      // the dedicated drawer/submenu rendered above it in the header markup.
      if (!desktop.matches) {
        closeAll();
        return;
      }
      clearTimeout(timer);
      body.classList.add('bt-mega-open');
      [].forEach.call(panels, function (p) {
        var isCurrent = p.getAttribute('data-mega-panel') === String(i);
        p.classList.toggle('is-open', isCurrent);
        p.setAttribute('aria-hidden', isCurrent ? 'false' : 'true');
      });
      [].forEach.call(triggers, function (t) { t.setAttribute('aria-expanded', t === trigger ? 'true' : 'false'); });
    }
    [].forEach.call(triggers, function (t) {
      var i = t.getAttribute('data-mega');
      t.addEventListener('mouseenter', function () { if (desktop.matches) open(i, t); });
      t.addEventListener('click', function (e) {
        if (!desktop.matches) return;
        if (t.hasAttribute('data-mega-direct')) return;
        e.preventDefault();
        if (t.getAttribute('aria-expanded') === 'true') closeAll(); else open(i, t);
      });
      t.addEventListener('focus', function () { if (desktop.matches) open(i, t); });
    });
    // hovering a nav item that has NO mega closes any open panel,
    // so only the trigger item (e.g. Catalog) ever shows it
    [].forEach.call(document.querySelectorAll('.bt-mainnav__item:not([data-mega])'), function (a) {
      a.addEventListener('mouseenter', closeAll);
    });
    [].forEach.call(panels, function (p) {
      p.addEventListener('mouseenter', function () { clearTimeout(timer); });
    });
    if (group) group.addEventListener('mouseleave', function () { timer = setTimeout(closeAll, 160); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    var syncMegaMode = function () { closeAll(); };
    if (desktop.addEventListener) desktop.addEventListener('change', syncMegaMode);
    else desktop.addListener(syncMegaMode);
    closeAll();
  })();

  /* ---------- search icon -> Dawn predictive search modal ---------- */
  (function () {
    var trigger = document.getElementById('btSearchTrigger');
    var summary = document.querySelector('.bt-searchmodal .header__search > details > summary');
    if (!trigger || !summary) return;   // no modal present -> link falls back to /search
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      // defer: Dawn's modal adds a "click outside closes" listener on open,
      // so this click must finish bubbling before we open it.
      setTimeout(function () {
        summary.click();
        var input = document.getElementById('Search-In-Modal');
        if (input) setTimeout(function () { input.focus(); }, 80);
      }, 0);
    });
  })();

  /* ---------- video play buttons ---------- */
  [].forEach.call(document.querySelectorAll('.bt-videoplay'), function (btn) {
    btn.addEventListener('click', function () {
      var media = btn.parentElement;
      var v = media && media.querySelector('video');
      if (v) { v.play(); btn.style.display = 'none'; return; }
      var embed = btn.getAttribute('data-video-embed');
      if (embed) {
        var img = media.querySelector('img'); if (img) img.remove();
        btn.insertAdjacentHTML('beforebegin', embed);
        btn.style.display = 'none';
      }
    });
  });

  /* ---------- reveal footer ---------- */
  (function () {
    var observer = null;
    var observedFooter = null;
    var footer = null;
    var main = null;
    var footerHeight = 0;
    var frame = 0;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function updateRevealPosition() {
      frame = 0;
      if (!footer || !main || !body.classList.contains('bt-reveal')) return;
      var overflow = Math.max(0, footerHeight - window.innerHeight);
      var offset = Math.min(overflow, Math.max(0, -main.getBoundingClientRect().bottom));
      footer.style.setProperty('--ibf-reveal-offset', -offset + 'px');
    }

    function queueRevealPosition() {
      if (!frame) frame = requestAnimationFrame(updateRevealPosition);
    }

    function syncRevealFooter() {
      footer = document.getElementById('btFooter') || document.querySelector('.bt-footer');
      main = document.getElementById('btMain') || document.getElementById('MainContent');
      footerHeight = footer ? Math.ceil(footer.getBoundingClientRect().height || footer.offsetHeight) : 0;
      var canReveal = !!(footer && main && footerHeight > 0 && !reducedMotion.matches);
      body.classList.toggle('bt-reveal', canReveal);
      body.classList.toggle('bt-reveal-tall', canReveal && footerHeight > window.innerHeight);
      document.documentElement.style.setProperty('--reveal-h', canReveal ? footerHeight + 'px' : '0px');
      if (footer && !canReveal) footer.style.removeProperty('--ibf-reveal-offset');
      updateRevealPosition();

      if ('ResizeObserver' in window && observedFooter !== footer) {
        if (observer) observer.disconnect();
        observedFooter = footer;
        if (footer) {
          observer = new ResizeObserver(function () { requestAnimationFrame(syncRevealFooter); });
          observer.observe(footer);
        }
      }
    }

    // Reveal keyboard-focused links even while the page layer covers the footer.
    document.addEventListener('focusin', function (event) {
      if (!footer || !main || !body.classList.contains('bt-reveal') || !footer.contains(event.target)) return;
      var rect = event.target.getBoundingClientRect();
      var pageBottom = main.getBoundingClientRect().bottom;
      if (rect.top < Math.max(0, pageBottom) || rect.bottom > window.innerHeight) {
        var offset = Math.min(Math.max(0, footerHeight - window.innerHeight), Math.max(0, -pageBottom));
        var naturalTop = rect.top + offset;
        window.scrollTo({ top: window.scrollY + pageBottom + naturalTop - window.innerHeight / 2, behavior: 'instant' });
        updateRevealPosition();
      }
    });

    syncRevealFooter();
    window.addEventListener('scroll', queueRevealPosition, { passive: true });
    window.addEventListener('resize', syncRevealFooter);
    window.addEventListener('load', syncRevealFooter);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', syncRevealFooter);
    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', syncRevealFooter);
    document.addEventListener('shopify:section:load', syncRevealFooter);
    document.addEventListener('shopify:section:unload', function () { requestAnimationFrame(syncRevealFooter); });
    if (document.fonts) document.fonts.ready.then(syncRevealFooter);
  })();
})();

/* ---------- hero progress indicator tied to the 10s autoplay ---------- */
(function () {
  var hero = document.getElementById('btHero'); if (!hero) return;
  // Mirror the slideshow: only a hidden tab pauses it. On return, restart progress
  // from zero so it matches the fresh 10s interval play() sets up.
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { hero.classList.add('is-paused'); return; }
    hero.classList.remove('is-paused');
    var d = hero.querySelector('.bt-hero__dot.is-active');
    if (d) { d.classList.remove('is-active'); void d.offsetWidth; d.classList.add('is-active'); }
  });
})();

/* ---------- footer: back to top ---------- */
(function () {
  var btn = document.querySelector('.bt-totop'); if (!btn) return;
  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'auto' });
  });
})();

/* ---------- product page: variant picker ---------- */
(function () {
  var pdp = document.querySelector('[data-pdp]'); if (!pdp) return;
  var dataEl = pdp.querySelector('[data-variants]'); if (!dataEl) return;
  var variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!variants || !variants.length) return;

  var idField  = pdp.querySelector('[data-variant-id]');
  var priceEl  = pdp.querySelector('[data-price]');
  var wasEl    = pdp.querySelector('[data-was]');
  var addBtn   = pdp.querySelector('[data-add]');
  var addText  = pdp.querySelector('[data-add-text]');
  var radios   = pdp.querySelectorAll('.bt-pdp__radio');
  if (!radios.length) return;

  var SOLD = addBtn ? (addBtn.getAttribute('data-sold') || 'Sold out') : 'Sold out';
  var ADD  = addText ? addText.textContent.trim() : 'Add to bag';

  function money(cents) {
    // Shopify prices are integer cents; format to the shop's currency symbol already in the DOM
    var sym = (priceEl.textContent.match(/^[^\d]*/) || [''])[0];
    return sym + (cents / 100).toFixed(2);
  }
  function chosen() {
    var out = [];
    [].forEach.call(radios, function (r) {
      if (r.checked) out[parseInt(r.getAttribute('data-opt-index'), 10)] = r.value;
    });
    return out;
  }
  function match(opts) {
    return variants.filter(function (v) {
      return opts.every(function (val, i) { return v['option' + (i + 1)] === val; });
    })[0];
  }
  function update() {
    var opts = chosen();
    var v = match(opts);

    // reflect the picked value next to each option label
    [].forEach.call(pdp.querySelectorAll('[data-opt-value]'), function (el) {
      var i = parseInt(el.getAttribute('data-opt-value'), 10);
      if (opts[i]) el.textContent = opts[i];
    });

    if (!v) {                                  // combination doesn't exist
      if (addBtn) { addBtn.disabled = true; }
      if (addText) addText.textContent = 'Unavailable';
      return;
    }
    if (idField) idField.value = v.id;
    if (priceEl) priceEl.textContent = money(v.price);
    if (wasEl) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        wasEl.textContent = money(v.compare_at_price); wasEl.hidden = false;
      } else { wasEl.hidden = true; }
    }
    if (addBtn) addBtn.disabled = !v.available;
    if (addText) addText.textContent = v.available ? ADD : SOLD;

    // keep the URL shareable without reloading
    if (window.history && history.replaceState) {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState({}, '', u);
    }
  }
  [].forEach.call(radios, function (r) { r.addEventListener('change', update); });
  update();
})();

/* ---------- product page: quantity stepper ---------- */
(function () {
  var box = document.querySelector('.bt-pdp__qtybox'); if (!box) return;
  var input = box.querySelector('[data-qty-input]');
  [].forEach.call(box.querySelectorAll('[data-qty]'), function (b) {
    b.addEventListener('click', function () {
      var step = parseInt(b.getAttribute('data-qty'), 10);
      var next = (parseInt(input.value, 10) || 1) + step;
      input.value = next < 1 ? 1 : next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
})();

/* ---------- product page: AJAX add to bag + cart drawer reveal ---------- */
(function () {
  var form = document.querySelector('.bt-pdp__form');
  if (!form) return;
  var button = form.querySelector('[data-add]');
  var label = form.querySelector('[data-add-text]');
  var status = form.querySelector('[data-add-status]');
  var cartDrawer = document.querySelector('cart-drawer');
  var busy = false;

  form.addEventListener('submit', function (event) {
    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function' || !window.routes) return;
    event.preventDefault();
    if (busy || !button || button.disabled) return;

    busy = true;
    var originalLabel = label ? label.textContent : '';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Adding…';
    if (status) { status.hidden = true; status.textContent = ''; }

    var formData = new FormData(form);
    formData.append('sections', cartDrawer.getSectionsToRender().map(function (section) { return section.id; }).join(','));
    formData.append('sections_url', window.location.pathname);
    if (typeof cartDrawer.setActiveElement === 'function') cartDrawer.setActiveElement(button);

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) throw new Error(response.description || response.message || 'This item could not be added.');
        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(response);
      })
      .catch(function (error) {
        if (status) {
          status.textContent = error.message || 'This item could not be added. Please try again.';
          status.hidden = false;
        }
      })
      .finally(function () {
        busy = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (label) label.textContent = originalLabel;
      });
  });
})();

/* ---------- product accordions: eased open / close instead of native snap ---------- */
(function () {
  var rows = document.querySelectorAll('.bt-pdp .bt-acc');
  if (!rows.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var timing = { duration: 520, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both' };

  [].forEach.call(rows, function (row) {
    var summary = row.querySelector('.bt-acc__head');
    var panel = row.querySelector('.bt-acc__body');
    if (!summary || !panel) return;
    summary.setAttribute('aria-expanded', row.open ? 'true' : 'false');

    function finish(animation, open) {
      animation.onfinish = function () {
        row._btAccAnimation = null;
        row.classList.remove('is-animating', 'is-closing');
        if (!open) row.open = false;
        animation.cancel();
      };
    }

    summary.addEventListener('click', function (event) {
      event.preventDefault();
      var opening = !row.open;

      if (row._btAccAnimation) {
        row._btAccAnimation.cancel();
        row._btAccAnimation = null;
        row.classList.remove('is-animating', 'is-closing');
      }

      if (reduce.matches) {
        row.open = opening;
        summary.setAttribute('aria-expanded', opening ? 'true' : 'false');
        return;
      }

      row.classList.add('is-animating');
      summary.setAttribute('aria-expanded', opening ? 'true' : 'false');

      if (opening) {
        row.open = true;
        var targetHeight = panel.scrollHeight;
        row._btAccAnimation = panel.animate([
          { height: '0px', opacity: 0, paddingBottom: '0px' },
          { height: targetHeight + 'px', opacity: 1, paddingBottom: '20px' }
        ], timing);
        finish(row._btAccAnimation, true);
      } else {
        row.classList.add('is-closing');
        var startHeight = panel.getBoundingClientRect().height;
        row._btAccAnimation = panel.animate([
          { height: startHeight + 'px', opacity: 1, paddingBottom: '20px' },
          { height: '0px', opacity: 0, paddingBottom: '0px' }
        ], timing);
        finish(row._btAccAnimation, false);
      }
    });
  });
})();

/* ---------- product gallery lightbox ---------- */
(function () {
  var shots = document.querySelectorAll('.bt-pdp__shot img');
  if (!shots.length) return;

  var srcs = [].map.call(shots, function (img) {
    // swap the CDN width param up for the full-size view
    return { src: img.currentSrc || img.src, alt: img.alt || '' };
  });

  var ICON_CLOSE = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
  var ICON_PREV  = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M19 12H5M11 6l-6 6 6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_NEXT  = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var lb = document.createElement('div');
  lb.className = 'bt-lb';
  lb.setAttribute('role', 'dialog');
  lb.setAttribute('aria-modal', 'true');
  lb.setAttribute('aria-label', 'Product image viewer');
  lb.innerHTML =
    '<button class="bt-lb__btn bt-lb__close" type="button" aria-label="Close">' + ICON_CLOSE + '</button>' +
    '<button class="bt-lb__btn bt-lb__prev" type="button" aria-label="Previous image">' + ICON_PREV + '</button>' +
    '<div class="bt-lb__stage"><img class="bt-lb__img" alt=""></div>' +
    '<button class="bt-lb__btn bt-lb__next" type="button" aria-label="Next image">' + ICON_NEXT + '</button>';
  document.body.appendChild(lb);

  var imgEl = lb.querySelector('.bt-lb__img');
  var prevBtn = lb.querySelector('.bt-lb__prev');
  var nextBtn = lb.querySelector('.bt-lb__next');
  var closeBtn = lb.querySelector('.bt-lb__close');
  var stage = lb.querySelector('.bt-lb__stage');
  var cur = 0, lastFocus = null;

  // a single image has nothing to page through
  if (srcs.length < 2) { prevBtn.hidden = true; nextBtn.hidden = true; }

  function show(i) {
    cur = (i + srcs.length) % srcs.length;
    imgEl.src = srcs[cur].src;
    imgEl.alt = srcs[cur].alt;
  }
  function open(i) {
    lastFocus = document.activeElement;
    show(i);
    lb.classList.add('is-open');
    document.body.classList.add('bt-lb-open');
    closeBtn.focus();
  }
  function close() {
    lb.classList.remove('is-open');
    document.body.classList.remove('bt-lb-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  [].forEach.call(shots, function (img, i) {
    img.addEventListener('click', function () { open(i); });
  });
  prevBtn.addEventListener('click', function () { show(cur - 1); });
  nextBtn.addEventListener('click', function () { show(cur + 1); });
  closeBtn.addEventListener('click', close);
  // clicking the empty area closes; clicking the photo itself does not
  lb.addEventListener('click', function (e) {
    if (e.target === lb || e.target === stage) close();
  });
  document.addEventListener('keydown', function (e) {
    if (!lb.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft' && srcs.length > 1) show(cur - 1);
    else if (e.key === 'ArrowRight' && srcs.length > 1) show(cur + 1);
    else if (e.key === 'Tab') {                       // keep focus inside the dialog
      var f = [closeBtn, prevBtn, nextBtn].filter(function (b) { return !b.hidden; });
      var i = f.indexOf(document.activeElement);
      e.preventDefault();
      f[(i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
    }
  });
})();

/* ---------- keep our cart icon after Dawn re-renders the bubble ----------
   cart-drawer.js replaces #cart-icon-bubble's contents on every cart update and
   injects Dawn's own icon. re-instate ours, carrying the new count across. */
(function () {
  var link = document.getElementById('cart-icon-bubble'); if (!link) return;
  var first = link.querySelector('svg'); if (!first) return;
  var OURS = first.outerHTML;
  var busy = false;

  function restore() {
    if (busy) return;
    if (link.querySelector('[data-ib-bag-icon]')) return;
    busy = true;
    var badge = link.querySelector('.cart-count-bubble, .bt-bag__count');
    // Dawn includes a visible count and a screen-reader label. Read one only.
    var countNode = badge && (badge.querySelector('[aria-hidden="true"]') || badge.querySelector('.visually-hidden') || badge);
    var n = countNode ? (countNode.textContent.match(/\d+/) || [''])[0] : '';
    link.setAttribute('aria-label', 'Shopping Bag, ' + (n || '0') + ' items');
    link.innerHTML = '<span class="bt-bag__icon">' + OURS + '<span class="bt-bag__count">' + (n || '0') + '</span></span>';
    busy = false;
  }
  new MutationObserver(restore).observe(link, { childList: true, subtree: true });
})();

/* ---------- image + text: parallax between the main photo and the inset ---------- */
(function () {
  var media = document.querySelector('.bt-imgtext__media[data-parallax]'); if (!media) return;
  var main = media.querySelector('.bt-imgtext__main');
  var inset = media.querySelector('.bt-imgtext__inset');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var wide = window.matchMedia('(min-width: 901px)');
  var ticking = false;

  function clear() {
    if (main) main.style.transform = '';
    if (inset) inset.style.transform = '';
  }
  function update() {
    ticking = false;
    // below 901px the columns stack and the inset is hidden, so there is nothing to offset
    if (reduce.matches || !wide.matches) { clear(); return; }
    var r = media.getBoundingClientRect(), vh = window.innerHeight;
    if (r.bottom < 0 || r.top > vh) return;          // off-screen: leave it where it is
    // -1 when the section sits below the fold, +1 once it has passed above it
    var p = ((r.top + r.height / 2) - vh / 2) / ((vh + r.height) / 2);
    if (p < -1) p = -1; else if (p > 1) p = 1;
    // opposite directions so the two photos visibly separate as you scroll,
    // and the inset tilts through level as it passes the middle of the viewport
    if (main) main.style.transform = 'translate3d(0,' + (p * -22).toFixed(2) + 'px,0)';
    if (inset) {
      inset.style.transform = 'translate3d(0,' + (p * 38).toFixed(2) + 'px,0) rotate(' + (p * -4).toFixed(2) + 'deg)';
    }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  if (reduce.addEventListener) reduce.addEventListener('change', update);
  update();
})();

/* ---------- testimonials: one review at a time, arrow-driven ---------- */
(function () {
  var box = document.getElementById('btTesti'); if (!box) return;
  var slides = box.querySelectorAll('.bt-testi__slide');
  if (slides.length < 2) return;
  var prev = box.querySelector('.bt-testi__arrow--prev');
  var next = box.querySelector('.bt-testi__arrow--next');
  var cur = 0, N = slides.length;

  function go(n) {
    n = (n + N) % N;
    slides[cur].classList.remove('is-active');
    slides[n].classList.add('is-active');
    cur = n;
  }
  if (prev) prev.addEventListener('click', function () { go(cur - 1); });
  if (next) next.addEventListener('click', function () { go(cur + 1); });
  // arrow keys once a control has focus, so it is not mouse-only
  box.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') { go(cur - 1); }
    else if (e.key === 'ArrowRight') { go(cur + 1); }
  });
})();
